import React from "react";
import { Form, Label, Checkbox } from "semantic-ui-react";

const CheckboxInput = ({
  input,
  width,
  label,
  meta: { touched, error },
  handleOnChange,
  checked,
}) => {
  return (
    <Form.Field error={touched && !!error} width={width}>
      <Checkbox
        value={input.value}
        label={label}
        onClick={(evt, { value, checked }) => {
          input.onChange({ target: { type: "checkbox", value, checked } });
          if (handleOnChange) handleOnChange(checked);
        }}
        onBlur={(e, data) => input.onBlur(data)}
        checked={checked}
        className="checkboxInput"
      />
      {touched && error && (
        <Label pointing basic color="red">
          {error}
        </Label>
      )}
    </Form.Field>
  );
};

export default CheckboxInput;
